import tutorialModelAIcon from "url:shared-assets/images/tutorialModelImages/tutorialModelD.svg";
import { useTranslation } from 'react-i18next';

const ModelD = (props: any) => {
  const translation = useTranslation();
  const { t } = translation;
  const variant = props.variant; // "D1" or "D2"
  return (
    <div className="z-modal-content-height">
      <div className="flex flex-col items-center gap-4">
        <img className="w-60 h-60" src={tutorialModelAIcon} alt="tutorialModelD" /></div>
      <div className="space-y-4 w-90 w-full h-54">
        <p className="z-title5">{t("step")} {props.currentStepNumber} {t("of")} {props.totalSteps}</p>
        <div className="z-heading2 gray-100">{t("modelD-title")}</div>
        <div className="space-y-4">
          {variant === "D1" ? (
            <p className="z-body1">{t("modelD1-description")}</p>
          ) : (
            <p className="z-body1">{t("modelD2-description")}</p>
          )}
          <p className="z-body1">{t("modelD-description-extented")}</p>
        </div>
      </div>
    </div>
  );
};

export default ModelD;